<template>
<modal name="moneyboxNotEmptyModal" width="50%" height="50%">
        <div class="p-5">
            <h2 class="text-center">В копилке еще остались деньги</h2>
            <div class="row justify-content-center p-3">
                <h3>Распределите копилку между участниками смены, перед тем, как закрыть смену.</h3>
            </div>
            <div class="text-center">
                <button type="button" class="btn btn-primary" @click="closeModal">Ок </button>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    methods: {
        closeModal() {
            this.$modal.hide('moneyboxNotEmptyModal')
        }
    }
}
</script>

<style scoped>
    .btn {
        padding: 10px 30px;
        background: linear-gradient(180deg, #C8FA92 0%, #B5E97C 50%);
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
        border-radius: 11px;
        font-size: 20px;
        color: #000;
    }
</style>
